function OtaBusterIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 10.5A2.5 2.5 0 0111 8h10a2.5 2.5 0 012.5 2.5v7A2.5 2.5 0 0121 20h-3.2l-3.1 2.7a.6.6 0 01-.98-.46V20H11a2.5 2.5 0 01-2.5-2.5v-7z"
        fill="currentColor"
      />
      <circle cx="23.5" cy="9.5" r="4.5" fill="currentColor" opacity="0.35" />
      <path
        d="M21.8 9.5l.9.9 1.9-2"
        stroke="#fff"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default OtaBusterIcon
